import { FeatureCollection, MultiPolygon, Point } from "geojson";
import { Pump } from "./pump";

export enum IrrigationSystemType {
    centerPivot = 1,
    drip = 2,
    linear = 3,
    gravity = 4,
}

export const IRRIGATION_SYSTEM_TYPE_I18N: Record<
    IrrigationSystemType,
    "center_pivot" | "drip" | "linear" | "gravity"
> = {
    [IrrigationSystemType.centerPivot]: "center_pivot",
    [IrrigationSystemType.drip]: "drip",
    [IrrigationSystemType.linear]: "linear",
    [IrrigationSystemType.gravity]: "gravity",
};

export interface Endgun {
    id: number;
    pivot: number;
    start_degree: number;
    stop_degree: number;
    is_on: boolean;
    created_by: number;
    last_modified_by: number;
}

export interface IrrigationSystem {
    id: number;
    created_by: number;
    last_modified_by: number;
    system_type: IrrigationSystemType;
    pivot_length: number;
    end_gun_range: number;
    pivot_start_degree: number;
    pivot_stop_degree: number;
    pivot_center: Point;
    pivot_max_timer: number;
    pivot_revolution_time: number;
    pivot_minimum_depth: number;
    end_gun_segments: Endgun[];
    name: string;
    treatment_sections: FeatureCollection<
        MultiPolygon,
        {
            section_number: number;
            start_degree: number;
            stop_degree: number;
            treatment: string;
        }
    >;
    field: number;
    boundary: MultiPolygon;
    pump: Pump;
    acres: number;
}

export function getIrrigationSystemDisplayName(
    system: Pick<IrrigationSystem, "name">,
    unnamedLabel: string,
): string {
    const name = system.name?.trim();
    if (name) return name;
    return unnamedLabel;
}

export function getIrrigationSystemSpeed(
    irrigationSystem: IrrigationSystem,
    depth: number,
): number {
    if (depth < 0) {
        return 0;
    }
    const { pivot_minimum_depth } = irrigationSystem;
    if (depth < pivot_minimum_depth) {
        return 0;
    }
    return parseFloat(((pivot_minimum_depth / depth) * 100).toFixed(2));
}

export function getIrrigationSystemDepth(
    irrigationSystem: IrrigationSystem,
    speed: number,
): number {
    if (speed < 0) {
        return 0;
    }
    const { pivot_minimum_depth } = irrigationSystem;
    return parseFloat((pivot_minimum_depth / (speed / 100)).toFixed(2));
}
